import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class AgentSitefService {
    private _agent_url = "https://127.0.0.1/agente/clisitef";
    private _sessao: any = {};

    public _processing: boolean;
    public _statusAgent: string = "Conectando Agente...";
    public _commandId: any = undefined;
    public _statusTitle: string = "";
    public _statusBody: any = "";

    private cupomFiscal: string = "";
    private empresa: string = "";
    private terminal: string = "";
    private parcelas: number = 1;
    private initialParams: string = "";
    private sitefIp: string = "";

    constructor(private sanitized: DomSanitizer) {
        this.getStatusAgent();
    }

    // ===========================================================================
    // Consulta sobre o estado do Agente CliSiTef

    getStatusAgent(): void {
        $.ajax({
            url: this._agent_url + "/state",
            type: "get",
            data: {},
        })
            .done(function (data) {
                return data;
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    // ===========================================================================
    // Funcoes para gerenciamento de Sessao: Criar/Finalizar, consultar sessão atual

    createSessionId(
        sitefIp: string,
        enterprise: string,
        terminal: string,
        sessionparams: string
    ) {
        var $this = this;
        var ret = [];
        $this._sessao.ret = ret;
        $this._sessao.continua = 0;
        $this._sessao.cupomFiscal = "";
        $this._sessao.dataFiscal = this.getCurrentDateNums();
        $this._sessao.horaFiscal = this.getCurrentTimeNums();

        $.ajax({
            url: $this._agent_url + "/session",
            type: "post",
            data: {
                sitefIp: sitefIp,
                storeId: enterprise,
                terminalId: terminal,
                sessionParameters: sessionparams,
            },
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    // Salva a sessionId e dados da conexao
                    $this._sessao.sessionId = data.sessionId;
                    $this._sessao.usandoSessao = 1;
                    $this._sessao.empresa = enterprise;
                    $this._sessao.terminal = terminal;
                    $this._sessao.siTefIP = sitefIp;

                    return data;
                } else {
                    return data.serviceStatus + " - " + data.serviceMessage;
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    destroiSessaoId(): void {
        var $this = this;
        var ret = [];
        $this._sessao.ret = ret;
        $this._sessao.continua = 0;
        $this._sessao.cupomFiscal = "";
        $this._sessao.dataFiscal = this.getCurrentDateNums();
        $this._sessao.horaFiscal = this.getCurrentTimeNums();

        $.ajax({
            url: $this._agent_url + "/session",
            type: "delete",
            //data:{
            //	"sessionId":sessao.sessionId,
            //},
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    return data;
                } else {
                    return data.serviceStatus + " - " + data.serviceMessage;
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });

        // Limpa a sessionId, independente de ter dado erro.
        $this._sessao.sessionId = "";
        $this._sessao.usandoSessao = 0;
    }

    getSessaoId() {
        var $this = this;

        $.ajax({
            url: $this._agent_url + "/session",
            type: "get",
            data: {},
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    // Salva a sessionId
                    $this._sessao.sessionId = data.sessionId;
                    $this._sessao.usandoSessao = 1;
                    return data;
                } else {
                    return data.serviceStatus + " - " + data.serviceMessage;
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    // ===========================================================================
    // Funções gerais

    getVersions() {
        var $this = this;

        $.ajax({
            url: this._agent_url + "/getVersion",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
            },
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    return data;
                } else {
                    return data.serviceStatus + " - " + data.serviceMessage;
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    // ===========================================================================
    // TEF
    // tipo = 1 - Venda simples: a sessão é criada internamente e destruida no final
    // tipo = 2 - Venda com sessão: usa-se a sessão criada previamente pela automção
    // funcao - código da função na IniciaFuncaoSiTefInterativo
    start(
        tipo: number,
        funcao: number,
        cupomFiscal: any,
        value: any,
        parcelas: number,
        operator: string,
        trnParams: string,
        sessionParams: string,
        sitefIp: string,
        empresa: string,
        terminal: string
    ) {
        var $this = this;
        var ret = [];
        $this._sessao.ret = ret;
        $this._sessao.continua = 0;
        $this._sessao.cupomFiscal = cupomFiscal;
        $this._sessao.dataFiscal = this.getCurrentDateNums();
        $this._sessao.horaFiscal = this.getCurrentTimeNums();
        $this.parcelas = parcelas;

        $this.cupomFiscal = cupomFiscal;
        $this.sitefIp = sitefIp;
        $this.empresa = empresa;
        $this.terminal = terminal;
        $this.parcelas = parcelas;
        $this.initialParams = sessionParams;

        $this._processing = true;

        var args: any = {};
        if (tipo == 1) {
            // Envia dados para uma nova sessão
            args.sitefIp = sitefIp;
            args.storeId = empresa;
            args.terminalId = terminal;
        } else if (tipo == 2 && $this._sessao.sessionId) {
            args.sessionId = $this._sessao.sessionId;
        }

        // Argumentos comuns
        args.functionId = funcao;
        args.trnAmount = value;
        args.taxInvoiceNumber = cupomFiscal;
        args.taxInvoiceDate = $this._sessao.dataFiscal;
        args.taxInvoiceTime = $this._sessao.horaFiscal;
        args.cashierOperator = operator;
        args.trnAdditionalParameters = trnParams;
        args.trnInitParameters = sessionParams;

        $.ajax({
            url: $this._agent_url + "/startTransaction",
            type: "post",
            data: jQuery.param(args),
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    return (
                        "Agente ocupado: " +
                        data.serviceStatus +
                        " " +
                        data.serviceMessage
                    );
                } else if (data.clisitefStatus != 10000) {
                    return "Retorno " + data.clisitefStatus + " da CliSiTef";
                } else {
                    // Inicia retornou 10000 (via clisitef)
                    $this._sessao.continua = 0;

                    // Salva a sessionId para usar na confirmacao
                    $this._sessao.sessionId = data.sessionId;

                    // Continua no fluxo de coleta
                    $this.continue("");
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${
                    xhr.status
                } -  ${thrownError} <br> ${xhr.responseText} "<br>" ${jQuery.param(args)}`;
            });
    }

    finish(
        confirma,
        reenviaParametrosSiTef,
        foraDoFluxo,
        cupomFiscal,
        sitefIp,
        empresa,
        terminal,
        sessionParams
    ) {
        var $this = this;
        var args: any = {
            confirm: confirma,
        };

        if (reenviaParametrosSiTef) {
            args.sitefIp = sitefIp;
            args.storeId = empresa;
            args.terminalId = terminal;
            args.taxInvoiceNumber = cupomFiscal;
            args.trnInitParameters = sessionParams;
            args.taxInvoiceDate =
                $this._sessao.dataFiscal || $this.getCurrentDateNums();
            args.taxInvoiceTime =
                $this._sessao.horaFiscal || $this.getCurrentTimeNums();
        } else {
            args.sessionId = $this._sessao.sessionId;
            args.taxInvoiceNumber = $this._sessao.cupomFiscal || cupomFiscal;
            args.taxInvoiceDate =
                $this._sessao.dataFiscal || $this.getCurrentDateNums();
            args.taxInvoiceTime =
                $this._sessao.horaFiscal || $this.getCurrentTimeNums();
            args.trnInitParameters = sessionParams;
        }

        $.ajax({
            url: $this._agent_url + "/finishTransaction",
            type: "post",
            data: args,
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    $this._statusTitle =
                        data.serviceStatus + " " + data.serviceMessage;

                    location.reload();
                } else {
                    if (foraDoFluxo) {
                        $this.clearSitefStorage();
                        return (
                            "serviceStatus:" +
                            data.serviceStatus +
                            "<br>" +
                            "clisitefStatus:" +
                            data.clisitefStatus
                        );
                    }
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    continue(dados) {
        var $this = this;
        // lembrete: chamada ajax é assincrona, então sai da função continua imediatamente]
        $.ajax({
            url: $this._agent_url + "/continueTransaction",
            type: "post",
            data: {
                sessionId: $this._sessao.sessionId,
                data: dados,
                continue: $this._sessao.continua,
            },
        })
            .done(function (data) {

                /*console.log("Continua Status=" + data.clisitefStatus +
			" Dados=" + data.data +
			" Comando=" + data.commandId +
			" TipoCampo=" + data.fieldId +
			" TamMin=" + data.fieldMinLength +
			" TamMax=" + data.fieldMaxLength);*/
                if (data.serviceStatus != 0) {
                    return data.serviceStatus + " " + data.serviceMessage;
                }

                if (data.clisitefStatus != 10000) {
                    var s = "";

                    if (data.clisitefStatus == 0) {
                        s = JSON.stringify($this._sessao.ret);
                        console.log(s);
                        s = s.replace(/},{/g, "},<br>{");
                        $this.finish(
                            1,
                            false,
                            false,
                            $this.cupomFiscal,
                            $this.sitefIp,
                            $this.empresa,
                            $this.terminal,
                            $this.initialParams
                        );
                    }
                    if (
                        data.clisitefStatus == -2 ||
                        data.clisitefStatus == -6
                    ) {
                        return "Cancelar operação? <br>" + s;
                    } else if (data.clisitefStatus == -5) {
                        return (
                            "Sem conexão SiTef " +
                            data.clisitefStatus +
                            "<br>" +
                            s
                        );
                    } else {
                        return (
                            "Finalizado - Retorno: " +
                            data.clisitefStatus +
                            "<br>" +
                            s
                        );
                    }
                }

                if (data.commandId != 23) {
                    // tratamento para nao piscar a tela (refresh)
                    var lastContents23: any = "";
                }
                $this._commandId = data.commandId;
                console.log("comando " + $this._commandId);
                switch (data.commandId) {
                    case 0:
                        var item = {
                            TipoCampo: data.fieldId,
                            Valor: data.data,
                        };
                        console.log("0");
                        // acumula o resultado em um JSON, pode ser usado no final da transação para POST ao servidor da automação
                        $this._sessao.ret.push(item);
                        // console.info("TipoCampo [" + data.fieldId + "] Valor[" + data.data + "]");

                        if (data.fieldId == 121) return data.data;

                        if (data.fieldId == 122)
                            return "Cupom Cliente: \n" + data.data;
                        //alert("TipoCampo = " + data.fieldId + " " + data.data);
                        $this.continue("");
                        break;

                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 15:
                        // document.getElementById("tef_titulo").innerHTML =
                        $this._statusTitle = data.data;
                        console.log("15");
                        $this.continue("");
                        break;

                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 16:
                        //Apaga display
                        //document.getElementById("tef_titulo").innerHTML = "";
                        $this._statusTitle = "";
                        console.log("16");
                        $this.continue("");
                        break;

                    case 22:
                        console.log("22");
                        $this._statusTitle = data.data;
                        $this.continue("");
                        break;

                    case 23:
                        console.log("23");
                        var contents = $this.sanitized.bypassSecurityTrustHtml(
                            '<button type="button" class="btn btn-primary" (click)="_sitefAgentService.cancel()"><i class="fa fa-save"></i><span>Cancelar</span></button>'
                        );
                        if (lastContents23 != contents) {
                            //document.getElementById("tef_corpo").innerHTML = contents;
                            $this._statusBody = contents;
                            lastContents23 = contents;
                        }
                        // document.getElementById("tef_corpo").style.display = "block";

                        // No comando 23, faz o reset da flag de continuidade, para sensibilizar tratamento de confirmações de cancelamento da clisitef.
                        setTimeout(function () {
                            $this.continue("");
                            $this._sessao.continua = 0;
                        }, 500);
                        break;

                    case 20:
                        console.log("20");
                        //document.getElementById("tef_titulo").innerHTML = data.data;
                        $this._statusTitle = data.data;

                        //document.getElementById("tef_corpo").innerHTML =
                        // '<table><tr><td><input type="BUTTON" class="btn1" value="Sim" onclick="continua(0);"/></td>' +
                        // '<td><input type="BUTTON" class="btn1" value="N&atilde;o" onclick="continua(1);"/></td></tr></table>';
                        //document.getElementById("tef_corpo").style.display = "block";

                        $this._statusBody =
                            $this.sanitized.bypassSecurityTrustHtml(
                                '<button type="button" class="btn btn-primary" (click)="_sitefAgentService.continue(0)"><i class="fa fa-save"></i><span>Sim</span></button>' +
                                    '<button type="button" class="btn btn-secondary-congress" (click)="_sitefAgentService.continue(1)"><i class="fa fa-arrow-left"></i><span>Não</span></button>'
                            );

                        break;

                    case 21:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 38:
                        console.log("38");

                        var si = data.data;
                        if (data.commandId == 21){
                            si = si.replace(/;/g, "<br/>");
                        }

                        $this._statusBody =
                            $this.sanitized.bypassSecurityTrustHtml(
                                '<table><tr><td colspan="2">' +
                                    si +
                                    '</td></tr><tr><td colspan="2"></td><input type="text" id="DADOS" onkeypress="trataTecla(event);"/></td></tr>' +
                                    '<tr><td><button type="button" class="btn btn-primary" (click)="_sitefAgentService.trataColeta(0)"><i class="fa fa-check"></i><span>Ok</span></button></td>' +
                                    '<td><button type="button" class="btn btn-primary" (click)="_sitefAgentService.trataColeta(-1)"><i class="fa fa-close"></i><span>Cancelar</span></button></td></tr></table>'
                            );

                        if (data.commandId == 30 && $this.parcelas > 1) {
                            //Define número de parcelas
                            $this.trataColeta(0, $this.parcelas);
                        } else if (
                            $this.parcelas > 1 &&
                            data.data.includes("Parcelado")
                        ) {
                            //Pula o passo de escolha do parcelamento 1 a vista, 2 pelo estabelecimento, 3 pela administradora, 4 consulta
                            $this.trataColeta(0, 2);
                        } else if (data.data.includes("Chip")) {
                            //1 - Magentico/chip 2 - Digitado
                            $this.trataColeta(0, 1);
                        } else {
                            //A vista
                            $this.trataColeta(0, 1);
                        }

                        break;

                    default:
                        $this._commandId = -1;
                        console.log("default");
                        $this._statusBody =
                            "Chegou uma captura desconhecida.[" +
                            data.commandId +
                            "]";

                        this.continue("");
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                alert(
                    "Erro: " +
                        xhr.status +
                        " - " +
                        thrownError +
                        "<br>" +
                        xhr.responseText
                );
            });
    }

    trataTecla(event, dados) {
        if (event.keyCode == 0x0d) this.trataColeta(0, dados);
    }

    trataColeta(cont: number, dados: number) {
        this._sessao.continua = cont;
        this.continue(dados);
    }

    // ===========================================================================
    // Funcoes de PinPad

    pinpadOpen() {
        var $this = this;

        $.ajax({
            url: this._agent_url + "/pinpad/open",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    return data.serviceStatus + " - " + data.serviceMessage;
                } else if (data.clisitefStatus == 0) {
                    return "PinPad aberto com sucesso";
                } else {
                    return "Retorno " + data.clisitefStatus + " da CliSiTef";
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    pinpadFecha() {
        var $this = this;

        $.ajax({
            url: this._agent_url + "/pinpad/close",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    return data.serviceStatus + " - " + data.serviceMessage;
                } else if (data.clisitefStatus == 0) {
                    return "PinPad fechado com sucesso";
                } else {
                    return "Retorno " + data.clisitefStatus + " da CliSiTef";
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    pinpadPresent() {
        var $this;
        $this.showStatus("Verificando presença do pinpad...");

        $.ajax({
            url: $this._agent_url + "/pinpad/isPresent",
            type: "post",
            data: {
                sessionId: $this._sessao.sessionId,
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    return data.serviceStatus + " - " + data.serviceMessage;
                } else if (data.clisitefStatus == 0) {
                    return false;
                } else if (data.clisitefStatus == 1) {
                    return true;
                } else {
                    return "Retorno " + data.clisitefStatus + " da CliSiTef";
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    pinpadMensagem(mensagem, persistente) {
        var $this = this;

        $.ajax({
            url: $this._agent_url + "/pinpad/setDisplayMessage",
            type: "post",
            data: {
                sessionId: $this._sessao.sessionId,
                displayMessage: mensagem,
                persistent: persistente ? "Y" : "N",
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    return data.serviceStatus + " - " + data.serviceMessage;
                } else {
                    this.resetView();
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    pinpadLeSimNao(mensagem) {
        var $this = this;

        $.ajax({
            url: this._agent_url + "/pinpad/readYesNo",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
                displayMessage: mensagem,
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    return data.serviceStatus + " - " + data.serviceMessage;
                } else if (data.clisitefStatus == 0) {
                    return "Tecla Anula pressionada";
                } else if (data.clisitefStatus == 1) {
                    return "Tecla Entra pressionada";
                } else {
                    return "Retorno " + data.clisitefStatus + " da CliSiTef";
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                return `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`;
            });
    }

    resetView() {
        this._statusTitle = "";
        this._statusBody = "";
        if (!this._sessao.usandoSessao) {
            // Foi usada uma sessao temporária, faz a limpeza pois o servidor removeu a sessão
            this._sessao.sessionId = 0;
        }
    }

    cancel() {
        this._sessao.continua = -1;
        //this._processing = false;
    }

    setInstallment() {}

    getCurrentTimeNums(): string {
        var d = new Date(); // for now
        let hour = d.getHours();
        let min = d.getMinutes();
        let sec = d.getSeconds();

        let newhour =
            hour.toString().length == 1 ? "0" + hour : hour.toString();
        let newmin = min.toString().length == 1 ? "0" + min : min.toString();
        let newsec = sec.toString().length == 1 ? "0" + sec : sec.toString();

        return newhour + newmin + newsec;
    }

    getCurrentDateNums(): string {
        var d = new Date(); // for now
        let day = d.getDay();
        let month = d.getMonth();
        let year = d.getFullYear();

        let formatDay = day.toString().length == 1 ? "0" + day : day.toString();
        let formatMonth =
            month.toString().length == 1 ? "0" + month : month.toString();
        let formatYear =
            year.toString().length == 1 ? "0" + year : year.toString();

        return formatYear + formatMonth + formatDay;
    }

    clearSitefStorage() {
        localStorage.removeItem("cupomClienteSitef");
        localStorage.removeItem("cupomLojaSitef");
        localStorage.removeItem("dadosSitef");
        localStorage.removeItem("pending-transaction");
    }
}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/checkout/agent-sitef/agent-sitef.service.ts